import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[h-scroll]',
})
export class HorizontalScrollDirectiveDirective implements OnDestroy {
  @Output() onScroll: EventEmitter<number> = new EventEmitter();

  private wheelListener: (e: WheelEvent) => void;

  constructor(private ele: ElementRef) {
    this.wheelListener = (event: WheelEvent) => {
      const target = this.ele.nativeElement as HTMLElement;
      const deltaY = (event as any)['deltaY'] ?? 0;
      const toLeft = deltaY < 0 && target.scrollLeft > 0;
      const toRight =
        deltaY > 0 && target.scrollLeft < target.scrollWidth - target.clientWidth;

      if (toLeft || toRight) {
        target.scrollLeft += deltaY as number;
        this.onScroll.emit(target.scrollLeft);
      }
    };

    this.ele.nativeElement.addEventListener('wheel', this.wheelListener, {
      passive: true,
    });
  }

  ngOnDestroy(): void {
    this.ele.nativeElement.removeEventListener('wheel', this.wheelListener);
  }
}
